import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'

export const Root = styled.div`
  text-align: center;
`

export const HeaderBottom = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding-bottom: ${rem(30)};

  ${mediaQueryUp.desktop} {
    margin-bottom: ${rem(60)};
  }
`

export const TextPanelContent = styled(LayoutContainer)`
  > * + * {
    margin-top: ${rem(25)};
  }
`

export const FinePrintLinks = styled.div`
  & > * {
    display: inline-block;
    padding: 1px ${rem(12)};
  }

  > * + * {
    border-left: 1px solid ${props => props.theme.palette.neutral.default.five};
  }
`

export const JoinPanel = styled.div`
  padding-top: ${rem(60)};
  padding-bottom: ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.six};
`

export const CommonHeaderTop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding-top: ${rem(30)};

  ${mediaQueryUp.desktop} {
    padding-top: ${rem(60)};
  }
`

export const CommonMainHeaderBox = styled(Pane)`
  display: inline-block;
  padding: ${rem(20)} ${rem(30)};
  color: ${props => props.theme.palette.neutral.default.one};

  ${mediaQueryUp.desktop} {
    padding: ${rem(30)} ${rem(60)};
  }
`

export const CommonStepBox = styled.div`
  height: 100%;
  padding: ${rem(30)};
  background-color: ${props => props.theme.palette.neutral.default.six};

  > * + * {
    margin-top: ${rem(10)};
  }
`

export const CommonStepNumber = styled.div`
  display: inline-flex;
  width: ${rem(30)};
  height: ${rem(30)};
  color: ${props => props.theme.palette.neutral.default.eight};
  background-color: ${props => props.theme.palette.brand.primary.normal};
  border-radius: ${props => props.theme.borderRadius.round};
  align-items: center;
  justify-content: center;
`
